import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-scroll';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__top">
          <Link to="hero" smooth="easeInOutCubic" duration={400} className="footer__logo">
            <span className="footer__bracket">[</span>
            <span className="footer__name">Sudip Majkoti</span>
            <span className="footer__accent">.ai</span>
            <span className="footer__bracket">]</span>
          </Link>
          <p className="footer__tagline">
            AI Engineer &bull; Architecting Intelligent Agents, Production RAG &amp; MLOps
          </p>
        </div>

        <div className="footer__socials">
          <a
            href="https://github.com/sudipmajkoti07"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
            title="GitHub Profile"
          >
            <FaGithub />
            <span>GitHub</span>
          </a>
          <a
            href="https://linkedin.com/in/sudipmajkoti"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
            title="LinkedIn Profile"
          >
            <FaLinkedin />
            <span>LinkedIn</span>
          </a>
          <a
            href="mailto:sudipmazkoti@gmail.com"
            aria-label="Email"
            title="Send Email"
          >
            <FaEnvelope />
            <span>Email</span>
          </a>
        </div>

        <div className="footer__copy">
          <p>
            &copy; {new Date().getFullYear()} Sudip Majkoti &bull; Built with React &bull; Bhaktapur, Nepal
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
